<template>
  <!-- 步骤条 -->
  <div class="step-main">
    <div class="step-main-item">
      <div class="title" :class="[active == 0 ? 'greenColor' : 'title']">
        {{ $t('feedDetailStatus1') }}
      </div>
      <div
        class="first-step"
        :class="[active >= 0 ? 'first-step' : 'linerGay']"
      >
        <div class="innter">
          <i v-if="active == 0">1</i>
          <van-icon v-else name="success" />
        </div>
      </div>
      <!-- <div class="time">2022/02/24</div> -->
    </div>
    <div class="inline" :class="[active >= 1 ? 'inline' : 'linerGay']"></div>
    <div class="step-main-item">
      <div class="title" :class="[active == 1 ? 'greenColor' : 'title']">
        {{ $t('feedDetailStatus2') }}
      </div>
      <div
        class="first-step"
        :class="[active >= 1 ? 'first-step' : 'linerGay']"
      >
        <div :class="[active >= 1 ? 'innter' : 'innerColor']">
          <i v-if="active <= 1">2</i>
          <van-icon v-else name="success" />
        </div>
      </div>
      <!-- <div class="time">2022/02/24</div> -->
    </div>
    <div class="inline2" :class="[active >= 2 ? 'inline2' : 'linerGay']"></div>
    <div class="step-main-item">
      <div class="title" :class="[active == 2 ? 'greenColor' : 'title']">
        {{ $t('feedDetailStatus3') }}
      </div>
      <div
        class="first-step"
        :class="[active >= 2 ? 'first-step' : 'linerGay']"
      >
        <div :class="[active >= 2 ? 'innter' : 'innerColor']">
          <i v-if="active <= 2">3</i>
          <van-icon v-else name="success" />
        </div>
      </div>
      <!-- <div class="time">2022/02/24</div> -->
    </div>
    <div class="inline3" :class="[active >= 3 ? 'inline3' : 'linerGay']"></div>
    <div class="step-main-item">
      <div class="title" :class="[active == 3 ? 'greenColor' : 'title']">
        {{ $t('orderStatus01') }}
      </div>
      <div
        class="first-step"
        :class="[active >= 3 ? 'first-step' : 'linerGay']"
      >
        <div :class="[active >= 3 ? 'innter' : 'innerColor']">
          <i v-if="active <= 3">4</i>
          <van-icon v-else name="success" />
        </div>
      </div>
      <!-- <div class="time">2022/02/24</div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: ["active"],
  data() {
    return {
      // active: 0,
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@function toVw($px) {
  @return ($px / 375) * 100vw;
}
@function toVh($px) {
  @return ($px / 667) * 100vh;
}
.detail-main {
  width: 100vw;
  height: 100%;
  overflow: auto;
  // padding: toVh(14) toVw(14);
  box-sizing: border-box;
  .step-main {
    display: flex;
    align-items: center;
    &-item {
      width: toVw(240);
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      .title {
        font-size: toVw(12);
        color: #202020;
      }
      .greenColor {
        color: #50b281;
      }
      .time {
        font-size: toVw(8);
        color: #909090;
        line-height: toVh(16);
      }
    }
  }
  .first-step {
    width: toVw(36);
    height: toVh(36);
    border-radius: 50%;
    background: #d5f1e5;
    margin: toVh(3) 0;
    position: relative;
    .innter {
      width: toVw(24);
      height: toVh(24);
      border-radius: 50%;
      background: #4bd891;
      margin: auto;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      color: #fff;
      font-size: toVw(14);
      line-height: toVh(24);
      text-align: center;
    }
  }
  .inline {
    width: toVw(60);
    height: toVh(10);
    background: #4bd891;
    position: absolute;
    left: 19.8%;
    top: toVh(46);
  }
  .inline2 {
    width: toVw(60);
    height: toVh(10);
    background: #4bd891;
    position: absolute;
    left: 43%;
    top: toVh(46);
  }
  .inline3 {
    width: toVw(60);
    height: toVh(10);
    background: #4bd891;
    position: absolute;
    left: 66%;
    top: toVh(46);
  }
  .linerGay {
    background: #ececee;
  }
  .innerColor {
    background: #c0c0c0;
    width: toVw(24);
    height: toVh(24);
    border-radius: 50%;
    margin: auto;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    color: #fff;
    font-size: toVw(14);
    line-height: toVh(24);
    text-align: center;
  }
}
</style>
